export default __webpack_public_path__ + "static/media/logo_blue.fdb644fd.svg";